import { setServiceTable } from './serviceConfig';
import { setServiceDetailTable } from './serviceDetailConfig';
import { setServiceListTable } from './serviceDetailListConfig';

export default function setTableCols (type = 'service') {
  const configs = {
    'service': setServiceTable.call(this),
    'serviceList': setServiceListTable.call(this),
    'serviceDetail': setServiceDetailTable.call(this),
  };

  configs[type].forEach(v => {
    if (!v.minWidth) {
      let title = v.label || v.title;

      v.minWidth = `${title.length * 16 + (v.sortable ? 30 : 20)}px`;
    }

    v.tooltip = true;
  });

  return configs[type];
}
